import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SubmissionRecords from "@/components/poshan/SubmissionRecords";

// Dedicated page for the Daily-Enrolment-Photos → Bill flow. Moved off the
// School Dashboard main view so the dashboard stays focused on quick links
// and verification status. Reachable from the "Bill Photos" quick-link tile.
export default function BillPhotos() {
  return (
    <div className="min-h-screen bg-sand-50">
      <Navbar />
      <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
        <Link
          to="/dashboard"
          data-testid="bill-photos-back-link"
          className="mb-4 inline-flex items-center gap-1.5 text-sm font-semibold text-clay hover:text-clay-dark"
        >
          <ArrowLeft className="h-4 w-4" /> Back to dashboard
        </Link>
        <SubmissionRecords />
      </div>
    </div>
  );
}
